module.exports = __webpack_public_path__ + "static/media/li-platforms.6b88f312.svg";